module.exports = __webpack_public_path__ + "img/logo-dtg.aa763291.png";